
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-short-text-v1',
    templateUrl: './fill-short-text-v1.component.html'
})
export class FillShortTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Type your answer here";
    public value: string = "";
    public valid: boolean = false;


    ngOnInit(): void {
        // Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.trim() !== '') {
            this.value = this.fieldSubmission.serialized_value;  // Set the value without triggering the input event
            this.valid = this.value.trim() !== ''; // Update validity
        }
        this.emitValidity();
    }

    onValueChange(value: string) {
        this.value = value;
        // Check for validity: non-empty string or optional field
        this.valid = value.trim() != '' || !this.fieldSubmission.field.mandatory; 

        // console.log(" Short TExt value----> ", value);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: value});
        this.emitValidity();
    }

    private emitValidity(): void {
        // This already manages for mandatory and non-mandatory fields
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
